<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     x="0px" y="0px" width="55" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;" xml:space="preserve">
														<g>
															<g id="add">
																<path d="M357,204H204v153h-51V204H0v-51h153V0h51v153h153V204z" />
															</g>
														</g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
  <g></g>
													</svg>
